import { render } from "./AdditionalSecondaryTitle.vue?vue&type=template&id=68b393b9"
const script = {}
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "68b393b9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('68b393b9', script)) {
    api.reload('68b393b9', script)
  }
  
  module.hot.accept("./AdditionalSecondaryTitle.vue?vue&type=template&id=68b393b9", () => {
    api.rerender('68b393b9', render)
  })

}

script.__file = "src/views/services/pageTitles/AdditionalSecondaryTitle.vue"

export default script